import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { FmdGood, WrongLocation } from '@mui/icons-material';


export function FacilityStatusCell({ active, classes }) {
  const isActive = Boolean(active);
  return (
    <Box className={classes?.facilityStatusRoot} display="flex" alignItems="center">
      {isActive ? (
        <FmdGood className={classes?.facilityStatusActiveIcon} />
      ) : (
        <WrongLocation className={classes?.facilityStatusInactiveIcon} />
      )}
      <Typography
        component="span"
        className={isActive ? classes?.facilityStatusActiveText : classes?.facilityStatusInactiveText}
      >
        {isActive ? 'Active' : 'Inactive'}
      </Typography>
    </Box>
  );
}

export default FacilityStatusCell;
